import { createSlice, createAsyncThunk, current } from '@reduxjs/toolkit';
import blockService from './blockService';

const initialState = {
  faqBlock: '',
  faqBlockError: false,
  faqBlockSuccess: false,
  faqBlockLoading: false,
  faqBlockErrorMsg: '',
};

export const creatingFaqBlock = createAsyncThunk(
  'faqBlock/creatingFaqBlock',

  async (data, thunkAPI) => {
    try {
      const response = await blockService.creatingFaqBlock(data);
      return response;
    } catch (error) {
      const faqBlockErrorMsg =
        (error.response && error.response.data && error.response.data.faqBlockErrorMsg) ||
        error.faqBlockErrorMsg ||
        error.toString();
      return thunkAPI.rejectWithValue(faqBlockErrorMsg);
    }
  }
);
export const faqSlice = createSlice({
  name: 'faqBlock',
  initialState,
  reducers: {
    resetUser: (state) => {
      state.faqBlockLoading = false;
      state.faqBlockSuccess = false;
      state.faqBlockError = false;
      state.faqBlockErrorMsg = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(creatingFaqBlock.pending, (state) => {
        state.faqBlockLoading = true;
      })
      .addCase(creatingFaqBlock.fulfilled, (state, action) => {
        state.faqBlockLoading = false;
        state.faqBlockSuccess = true;
        state.faqBlock = action.payload;
      })
      .addCase(creatingFaqBlock.rejected, (state, action) => {
        state.faqBlockLoading = false;
        state.faqBlockError = true;
        state.faqBlockErrorMsg = action.payload; // error from catch will come here via action.payload and update faqBlockErrorMsg
      });
  },
});
export const { resetUser } = faqSlice.actions;
export default faqSlice.reducer;
